'use client';

import Link from 'next/link';

interface ComingSoonModalProps {
  isOpen: boolean;
  onClose: () => void;
  type: 'signup' | 'payment' | 'upgrade';
}

export default function ComingSoonModal({ isOpen, onClose, type }: ComingSoonModalProps) {
  if (!isOpen) return null;

  const content = {
    signup: {
      title: 'Coming Soon!',
      message: 'User accounts and authentication are launching soon.',
      details: 'In the meantime, all tools and content are completely free to use without an account. Sign up for our newsletter to be notified when accounts go live!',
    },
    payment: {
      title: 'Coming Soon!',
      message: 'Paid subscriptions and premium features are launching soon.',
      details: 'In the meantime, all tools and content are completely free to use. Sign up for our newsletter to be notified when premium features go live!',
    },
    upgrade: {
      title: 'Coming Soon!',
      message: 'Paid subscriptions and upgrades are launching soon.',
      details: 'In the meantime, all premium features are available for free. Sign up for our newsletter to be notified when paid plans go live!',
    },
  };

  const { title, message, details } = content[type];

  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4">
      <div className="bg-background border-2 border-accent rounded-xl max-w-lg w-full p-8 relative animate-fadeIn">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-foreground-tertiary hover:text-foreground transition-colors"
          aria-label="Close"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        <div className="text-center">
          <div className="text-6xl mb-4">🚧</div>
          <h2 className="text-3xl font-bold text-accent mb-4">{title}</h2>
          <p className="text-xl text-foreground mb-6">{message}</p>
          <p className="text-foreground-secondary mb-8">{details}</p>

          <div className="space-y-3">
            <button
              onClick={onClose}
              className="w-full bg-accent text-accent-foreground px-6 py-3 rounded-lg font-semibold hover:bg-accent-hover transition-colors"
            >
              Continue Exploring (Free)
            </button>
            <Link
              href="/newsletter"
              onClick={onClose}
              className="block w-full bg-surface border border-border text-accent px-6 py-3 rounded-lg font-semibold hover:border-accent hover:bg-accent-muted transition-colors"
            >
              Subscribe to Newsletter
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
